import AdForgeDefaultsSection from "./AdForgeDefaultsSection"
import AdsQaScheduleSection from "./AdsQaScheduleSection"

/**
 * Settings → Ad Blaster: every AdBlaster/AdForge company-level setting in one
 * place (moved here from the AdBlaster page's header modals):
 *   • AdForge defaults — destination URL, default CTA, ad-name template, and
 *     the per-(objective, goal) CTA rules matrix.
 *   • Ads QA schedule — the daily read-only Meta ads QA job + Slack users to tag.
 */
export default function AdBlasterSettingsPage() {
  return (
    <div className="flex max-w-[860px] flex-col gap-system-lg py-system-md">
      <AdForgeDefaultsSection />
      <AdsQaScheduleSection />
    </div>
  )
}
